const { protocol, host } = window.location;

const API_CONFIG = {
  API_BASE_URL:
    process.env.NODE_ENV === "development"
      ? //? "http://localhost:3001/v1"
        "https://apis.fourseasonsfresh.in/v1"
      : `${protocol}//apis.${host.replace("www.", "")}/v1`,
  HEADERS: {
    POST: {
      headers: {
        "Content-Type": "application/json",
      },
    },
    GET: {
      headers: {
        "Content-Type": "application/json",
      },
    },
    PUT: {
      headers: {
        "Content-Type": "application/json",
      },
    },
    DELETE: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  },
};

const RESPONSE_STATUSES = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed",
  EXPIRED: "Expired",
  TWOFA: "2FA",
};

const LOGIN_TYPES = {
  PASSWORD: "PASSWORD",
  OTP: "OTP",
};

const OTP_VERIFICATION_TYPES = {
  REGISTER: "REGISTER",
  LOGIN: "LOGIN",
  RESET_PASSWORD: "RESET_PASSWORD",
  TWOFA: "2FA",
};

export { API_CONFIG, RESPONSE_STATUSES, LOGIN_TYPES, OTP_VERIFICATION_TYPES };
